import { DatePicker } from 'uikit';
import type { DatePickerPropValue } from 'uikit';

import { useCallback, useState } from 'react';

import Styles from './historyDateRangeFilter.module.css';

export const HistoryDateRangeFilter = ({
    onDateRangeChange,
}: {
    onDateRangeChange: ({ filterType, value }: { filterType: 'dateFilter'; value: [Date?, Date?] | null }) => void;
}) => {
    const [dateRange, setDateRange] = useState<[Date?, Date?] | null>(null);

    const handleDateChange = useCallback(
        ({ value }: { value: DatePickerPropValue<'date-range'> }) => {
            setDateRange(value);

            if (value?.[0] && value?.[1]) {
                onDateRangeChange({
                    filterType: 'dateFilter',
                    value,
                });
            } else {
                onDateRangeChange({
                    filterType: 'dateFilter',
                    value: null,
                });
            }
        },
        [onDateRangeChange],
    );

    return (
        <DatePicker
            size="s"
            value={dateRange}
            onChange={handleDateChange}
            type="date-range"
            withClearButton
            className={Styles.dateRangeContainer}
        />
    );
};

HistoryDateRangeFilter.displayName = 'HistoryDateRangeFilter';
